import type {SxProps} from '@mui/material';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import type {Dayjs} from 'dayjs';
import type {FC} from 'react';
import {useTranslation} from 'react-i18next';
import ChipStatus from '@/components/common/ChipStatus';
import type {STATUS} from '@/domain/entities/ForestMassStatus';

//TYPES
type Props = {
  id: STATUS;
  date: Dayjs;
};

const StatusInfo: FC<Props> = ({id, date}) => {
  const {t} = useTranslation();

  return (
    <Stack sx={styles.container}>
      <ChipStatus id={id} />
      <Stack direction="row" spacing={1} sx={styles.dateContainer}>
        <Typography variant="body2" sx={styles.text}>
          {t('status.date')}
        </Typography>
        <Typography variant="body2" sx={styles.text}>
          {date.format('YYYY-MM-DD')}
        </Typography>
      </Stack>
    </Stack>
  );
};
export default StatusInfo;

const styles: Record<string, SxProps> = {
  container: {
    gap: 0.5,
  },
  dateContainer: {
    alignItems: 'center',
  },
  text: {
    color: 'grey.700',
    fontStyle: 'italic',
  },
};
